import darkLogo from '../../assets/logo-dark.svg';

const HeaderLogoDark = () => (
    <img src={darkLogo} alt='Sky blue, royal blue, and yellow SetterSocial logo' style={{ display: 'flex', width: '20rem', height: 'auto', paddingTop: '4rem'}} />
);

export default HeaderLogoDark;